import {
  BodyText,
  Flex,
  Heading,
  Spinner,
  Strong,
} from '@utilitywarehouse/hearth-react';
import { useCallback } from 'react';

import { DialogUnwrapped } from '@components/Dialog';

import { AnimatedTextReveal } from '../AnimatedTextReveal';
import './styles.scss';

const START_LOADER_CLASS = 'start-loader';
const SCROLL_PADDING_MODIFIER = 'h-ModalScrollPadding--start-loader';

const StartLoader = () => {
  const callbackRef = useCallback((node: HTMLDivElement | null) => {
    const scrollPadding = node?.closest('.h-ModalScrollPadding');
    scrollPadding?.classList.add(SCROLL_PADDING_MODIFIER);
  }, []);

  return (
    <DialogUnwrapped
      open
      heading=""
      hideCloseButton
      preventDismiss
      className={START_LOADER_CLASS}
    >
      <Flex
        ref={callbackRef}
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing="xl"
      >
        <Spinner size="lg" />
        <Heading as="h2" size="lg" textAlign="center">
          Just a moment while we check what we can offer you...
        </Heading>
        <AnimatedTextReveal
          lines={[
            <BodyText textAlign="center">
              <Strong>One</Strong> bill, <Strong>one</Strong> account,{' '}
              <Strong>one</Strong> app...
            </BodyText>,
            <BodyText textAlign="center">
              Add more services to <Strong>save more</Strong> on your energy...
            </BodyText>,
            <BodyText textAlign="center">
              Earn up to <Strong>15% cashback</Strong> with our Cashback Card...
            </BodyText>,
          ]}
        />
      </Flex>
    </DialogUnwrapped>
  );
};

export { StartLoader };
